<template>
  <v-list class="pb-0 productList">
    <h4 class="px-6">
      {{$translate('SHOPPINGCART')}}:
    </h4>
    <template v-for="(order, orderIndex) in orders">
      <!-- Shopping cart item for Tickets -->
      <v-list-item
        :key="orderIndex"
        v-if="order.ShoppingCartType === 'Ticket'"
      >
        <template v-slot:default="{ active, toggle }">
          <v-list-item-avatar>
            <v-img max-width="35" max-height="35" :src="order.Picture"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="order.Name"/>
            <v-list-item-subtitle
              v-for="(priceCategory, priceCategoryIndex) in order.PriceCategories"
              :key="'priceCategoryIndex' + priceCategoryIndex + 'index' + orderIndex"
            >
              <b>{{priceCategory.PriceCategoryName}} ({{priceCategory.Quantity}})</b>
              || {{ $translate('UNIT_PRICE') }}: {{formatter.format(priceCategory.PriceCategoryPrice)}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-row>
              <v-col class="pa-0 pl-2" align="end">
                <h3>
                  {{
                  formatter.format(order.OrderTotalPrice)
                  }}
                </h3>
              </v-col>
              <v-divider vertical class="px-2" />
            </v-row>
          </v-list-item-action>
        </template>
      </v-list-item>
      <!-- Shopping cart item for Products and Rentals -->
      <template v-else v-for="(product, productIndex) in order.Products">
        <v-list-item
          :key="'productIndex' + productIndex + 'index' + orderIndex"
        >
          <template
            v-slot:default="{ active, toggle }"
          >
            <v-list-item-avatar>
              <v-img max-width="35" max-height="35" :src="product.Picture">
              </v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                v-text="product.ProductName"
              >
              </v-list-item-title>
              <v-list-item-subtitle v-if="product.ProductType === 'Weighted'">
                {{ product.Quantity }} {{product.Unit }}
              </v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="product.ItemDefs != null && Object.keys(product.ItemDefs)">
                <p
                  class="ma-0"
                  v-for="option in Object.entries(product.ItemDefs)"
                  :key="option"
                >
                  {{ option[0] }}: {{ option[1] }}
                </p>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-row>
                <v-col class="pa-0 pl-2" align="end">
                  <h3>
                    {{
                    formatter.format(product.ItemTotalPrice)
                    }}
                  </h3>
                  <v-list-item-subtitle v-if="product.ProductType !== 'Weighted'">
                    {{ $translate("QUANTITY") }}:
                    {{product.Quantity}}
                  </v-list-item-subtitle>
                </v-col>
                <v-divider vertical class="px-2" />
              </v-row>
            </v-list-item-action>
          </template>
        </v-list-item>
      </template>
    </template>
  </v-list>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ShoppingCartList',
  data() {
    return {
      formatter: new Intl.NumberFormat(
        'nl',
        { style: 'currency', currency: 'EUR' },
      ),
    };
  },
  computed: {
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),
  },
};
</script>

<style scoped>
.productList {
  max-height: 70%;
}
</style>
